import styles from './FeatureGarden.module.scss';
import stylesPills from './PillBubble/PillBubble.module.scss';

import React, { FC } from 'react';

import { AppType } from 'services/cms/typesUtil';
import { FadeToastUp } from 'components/Animation/FadeToastUp/FadeToastUp';
import { FeatureGardenModule, Subject } from 'api/contentful/contentTypes.cloverdotcom';
import { FlatEntry, flattenContentfulData } from 'services/cms/flattenContentful';
import { INLINES } from '@contentful/rich-text-types';
import { PillButton } from './PillButton/PillButton';
import { TextV2 } from 'components/TextV2/TextV2';
import { useBreakpoints } from 'hooks/useBreakpoints';

export type FeatureGardenProps = AppType.Component<FlatEntry<FeatureGardenModule>>;
export type BubblePositon = {
  left: number;
  top: number;
  width: number;
  initialWidth: number;
  height: number;
};
export type FeatureGardenPillProps = AppType.Component<
  FlatEntry<Subject> & {
    titleStyle: 'modern-body-large' | 'modern-h3';
    isModalOpen: boolean;
    onRequestClose?(): void;
  }
>;

export const FeatureGarden: FC<FeatureGardenProps> = ({ id, internalName, paragraph, _attributes }) => {
  const { browser } = useBreakpoints();
  const isMobile = browser.is.mobile;
  if (!paragraph || paragraph?.content.length === 0 || paragraph?.content.at(0)?.content.length === 0)
    return null;

  const closeAllBubbles = () => {
    document
      .querySelectorAll<HTMLButtonElement>(`.${stylesPills.pillCloseBubbleButton}`)
      .forEach(button => button.click());
  };

  const content = paragraph.content.at(0)?.content ?? [];
  const titleStyle = isMobile ? 'modern-body-large' : 'modern-h3';
  const paragraphElements = content.map(node => {
    if (node.nodeType === INLINES.EMBEDDED_ENTRY) {
      const flatEntry = flattenContentfulData<Subject>(node.data.target);
      return (
        <PillButton
          key={flatEntry?.id}
          onRequestClose={closeAllBubbles}
          {...flatEntry}
          titleStyle={titleStyle}
        />
      );
    }

    if (node.nodeType === 'text') {
      return (
        <TextV2
          className={styles.text}
          key={node.value}
          variant={titleStyle}
          value={node.value}
          tagName="span"
        />
      );
    }

    return null;
  });

  return (
    <section key={id} id={internalName} className={styles.featureGardenWrapper} {..._attributes}>
      <FadeToastUp>
        <p className={styles.featureGarden}>{paragraphElements.map(p => p)}</p>
      </FadeToastUp>
    </section>
  );
};
